(()=>{
 if(window.radicalChromeLoaded)return;window.radicalChromeLoaded=true;
 if(!customElements.get('radical-chrome'))customElements.define('radical-chrome',class extends HTMLElement{
  connectedCallback(){
   this.abort=new AbortController();const signal=this.abort.signal;
   const panels=[...this.querySelectorAll('details')];
   const update=()=>this.classList.toggle('is-scrolled',window.scrollY>40);
   window.addEventListener('scroll',update,{passive:true,signal});update();
   panels.forEach(panel=>panel.addEventListener('toggle',()=>{if(panel.open)panels.forEach(other=>{if(other!==panel)other.open=false;});},{signal}));
   this.addEventListener('keydown',event=>{if(event.key==='Escape'){const active=panels.find(p=>p.open);if(active){active.open=false;active.querySelector('summary').focus();}}},{signal});
   this.querySelectorAll('.rc-mobile-panel a').forEach(link=>link.addEventListener('click',()=>{panels.forEach(p=>p.open=false);},{signal}));
   document.addEventListener('click',event=>{if(!this.contains(event.target))panels.forEach(p=>p.open=false);},{signal});
  }
  disconnectedCallback(){this.abort?.abort();}
 });
 function footers(){document.querySelectorAll('[data-radical-footer]:not([data-observed])').forEach(footer=>{
  footer.dataset.observed='true';
  if(!('IntersectionObserver' in window)){footer.classList.add('is-seen');return;}
  const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){footer.classList.add('is-seen');observer.disconnect();}},{threshold:1});observer.observe(footer.querySelector('.rc-footer-line'));
 });}
 footers();document.addEventListener('shopify:section:load',footers);
})();
